import {Component, Input, OnInit} from '@angular/core';
import {SidebarNavService} from "@app/shared/cs-components/sidebar-nav/services/sidebar-nav.service";
import {INodeOptions, NodeOptionsObject} from "@app/workflow-common/diagram-view2/models/node.model";
import {DagSourceModel, InitialBlock} from "@app/workflow-common/services/DagSourceModel";
import {WorkflowDataInterface} from "@app/workflow-common/services/workflow-observable.service";
import {ConfirmModalConfig, WarningModalConfig} from "@app/interfaces/common-modal-popups";
import {WorkflowhttpService} from "@app/workflow-common/services/workflowhttp.service";
import { CommonDataSource } from "@app/workflow-common/services/CommonDataSource";
import {CsToastBoxService} from "@app/services";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-automation-step',
  templateUrl: './automation-step.component.html',
  styles: []
})
export class AutomationStepComponent implements OnInit {

    @Input() sidebarNavService: SidebarNavService;
    @Input() dagSource: {
        [key: string]: any
    } = undefined;
    @Input() objectName: string;
    @Input() settingsTypeId: number;
    @Input() screenName: string;
    @Input() metaData: any;
    @Input() workflowData: WorkflowDataInterface = undefined;
    @Input() isDraftMode: boolean = undefined;
    @Input() closeFullScreenModal: Function = undefined;

    statusActivationConfirmation: ConfirmModalConfig;
    warningModalConfig: WarningModalConfig;
    currentStep: string = 'custom_automation'
    nodeOptions: INodeOptions;
    nodes: InitialBlock[] = [];
    isValid: boolean = false;
    constructor(
        private _workflowHttp: WorkflowhttpService,
        private _toastBox: CsToastBoxService,
        private _translate: TranslateService
    ) { }



    ngOnInit() {
        console.log('AutomationStepComponent', this.workflowData, this.dagSource, this.metaData)
        this.nodeOptions = new NodeOptionsObject({
            title: this.metaData.name,
            objectName: this.objectName,
            enablePan: true,
            workflowType: 'CustomAutomation',
            showAddChild: true,
            metaData: this.metaData,
            isDraftMode: !!this.workflowData.status == false,
            autosave: true,
            workflowId: this.workflowData ? this.workflowData.id : undefined,
        });
        this.setActivationConfirmationModalConfig();
        this.setWarningModalConfig();
        const _dagSource = this.dagSource ? Object.values(this.dagSource) : [];
        if(_dagSource.length) {
            this.isValid = this.dagSource['endBlocks'].length > 0
        }
    }

    onUpdatedNode(dagSourceModel: DagSourceModel) {
        this.isValid = dagSourceModel.endBlocks.length > 0;
    }

    goBack() {
        this.sidebarNavService.goTo(this.currentStep, 'prev')
    }

    goToNext() {
        if(this.metaData['status'].toLowerCase() != 'active') {
            this.warningModalConfig.showModal=true;
            return;
        }
        if(!this.workflowData) {
            this.closeFullScreenModal();
            return;
        }
        const {status} = this.workflowData;
        if(status) {
            this.closeFullScreenModal();
        }
        else {
            this.statusActivationConfirmation.showModal=true;
        }
    }

    setWarningModalConfig() {

        this.warningModalConfig = {
            showModal: false,
            modalType: 'warning',
            title: 'Activation blocked',
            message: {
                warningTxt: this._translate.instant('Automation.activation.warning.message', {
                    screenType: CommonDataSource.automationTitleReplace[this.screenName]
                }),
                helpTxtList: []
            }
        }
    }
    setActivationConfirmationModalConfig() {
        this.statusActivationConfirmation = {
            modalType: 'confirm',
            actionText: 'ACTIVATE',
            confirmBtnType: 'DEFAULT',
            confirmBtnText: "ACTIVATE",
            confirmBxValidationMsg: '',
            itemText: "Automation",
            showModal: false,
            closeText: 'Save as draft',
            // message: {warningTxt: 'Confirm.Status.Activation.Message', helpTxtList: []},

            message: {
                warningTxt: 'Confirm.Status.Activation.Message',
                helpTxtList: ['Automation.Activate.Now.Or.Save.As.Draft']
            },
            title: 'Confirm.Activation',
            doAction: this.activateAutomation.bind(this),
            actionArg: '',
        }
    }

    activateAutomation(args, cb) {
        const {id, status} = this.workflowData;
        const automationActivate = {
            workflowId: id,
            status: true
        };
        this._workflowHttp.automationStatusUpdate(id, {automationActivate})
        .subscribe({
            next: resp => {
                if(resp.hasOwnProperty('automationActivate')) {
                    cb('SUCCESS');
                    this.closeFullScreenModal();
                }
                if(resp.hasOwnProperty('error')) {
                    this._toastBox.show(resp['message']);
                }
            }
        });
    }

    onCloseConfirmation(isCloseBtn:string, type:string) {
        this.closeFullScreenModal();
    }

}
